var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 28,
    viewBox: "0 0 60 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 27,
    rx: 4,
    ry: 4,
    fill: "#FFF",
    stroke: "#233A80"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#233A80",
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 500
  }, "\n    M\xE9dia\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageIcon);
export default __webpack_public_path__ + "static/media/AverageIcon.8fe2081db857dd6f878ec8e0c6de59b3.svg";
export { ForwardRef as ReactComponent };